import { type CreateSigningKeyChangeInput } from '../../API';
import { getDbSyncer } from '../LocalDB/DbSyncer';
import { getDb } from '../LocalDB/LocalDB';
import { type WithId } from '../LocalDB/types';

export const putSigningChange = async (input: CreateSigningKeyChangeInput & WithId) => {
    const table = getDb().signingKeyChanges;
    await table.put(input);
    await getDbSyncer().markToSync(table, input.id);
};
